module.exports = __webpack_public_path__ + "static/media/left_panel.e078c0ff.svg";